import React, { useEffect, useRef } from "react";
import { ArrowRight } from "lucide-react";

// const PREFERENCE_DISPLAY_MAPPING = {
//   size: {
//     XS: "Size XS",
//     S: "Size S",
//     M: "Size M",
//     L: "Size L",
//     XL: "Size XL",
//     XXL: "Size XXL",
//     XXXL: "Size XXXL",
//     custom: "Custom Size",
//     standard: "Standard Size",
//     compact: "Compact Size",
//     large: "Large Size",
//     medium: "Medium Size",
//     small: "Small Size",
//     "one size": "One Size Fits All",
//     other: "Other Size",
//   },
//   material: {
//     cotton: "Cotton",
//     leather: "Leather",
//     synthetics: "Synthetics",
//     metal: "Metal",
//     wood: "Wood",
//     glass: "Glass",
//     plastic: "Plastic",
//     ceramic: "Ceramic",
//     rubber: "Rubber",
//     wool: "Wool",
//     silk: "Silk",
//     paper: "Paper",
//     stone: "Stone",
//     composite: "Composite",
//     "natural fibers": "Natural Fibers",
//     bamboo: "Bamboo",
//     gold: "Gold",
//     silver: "Silver",
//     other: "Other Material",
//   },
//   category: {
//     fashion: "Fashion",
//     accessories: "Accessories",
//     jewelry: "Jewelry",
//     footwear: "Footwear",
//     electronics: "Electronics",
//     furniture: "Furniture",
//     appliances: "Appliances",
//     sports: "Sports",
//     outdoor: "Outdoor",
//     beauty: "Beauty",
//     health: "Health",
//     automotive: "Automotive",
//     "home decor": "Home Decor",
//     "toys & games": "Toys & Games",
//     books: "Books",
//     grocery: "Grocery",
//     "office supplies": "Office Supplies",
//     garden: "Garden",
//     "pet supplies": "Pet Supplies",
//     "tools & hardware": "Tools & Hardware",
//     "art & collectibles": "Art & Collectibles",
//     "baby & kids": "Baby & Kids",
//     "travel & luggage": "Travel & Luggage",
//     other: "Other Category",
//   },
//   condition: {
//     new: "Condition: New",
//     refurbished: "Condition: Refurbished",
//     used: "Condition: Used",
//     vintage: "Condition: Vintage",
//   },
//   gender: {
//     male: "Men's",
//     female: "Women's",
//     other: "Gender Neutral",
//     "none-specified": "Unisex",
//   },
//   countryOfOrigin: {
//     "Made in USA": "Made in USA",
//     "Assembled in USA": "Assembled in USA",
//     "Made in EU": "Made in EU",
//     "Made in China": "Made in China",
//     Other: "Other Origin",
//   },
//   shipping: {
//     "Free shipping": "Free Shipping",
//     "Same day shipping": "Same Day Shipping",
//     Other: "Other Shipping",
//   },
//   sustainability: {
//     organic: "Organic",
//     recycled: "Recycled Materials",
//     biodegradable: "Biodegradable",
//     "fair trade": "Fair Trade",
//     "eco-friendly": "Eco-Friendly",
//     none: " ",
//   },
//   use_case: {
//     "everyday use": "Everyday Use",
//     "special occasions": "Special Occasions",
//     "professional settings": "Professional Use",
//     "outdoor adventures": "Outdoor Activities",
//     "fitness activities": "Fitness & Exercise",
//     "home decor": "Home Decoration",
//     entertainment: "Entertainment",
//     "personal care": "Personal Care",
//     traveling: "Travel Use",
//     "hobby & crafts": "Hobbies & Crafts",
//     "educational purposes": "Educational",
//     "social gatherings": "Social Events",
//     gaming: "Gaming",
//     gifting: "Gift Giving",
//     collecting: "Collecting",
//     other: "Other Use",
//   },
//   style: {
//     minimalist: "Minimalist Style",
//     modern: "Modern Style",
//     vintage: "Vintage Style",
//     classic: "Classic Style",
//     bold: "Bold Style",
//     casual: "Casual Style",
//     formal: "Formal Style",
//     rustic: "Rustic Style",
//     industrial: "Industrial Style",
//     bohemian: "Bohemian Style",
//     futuristic: "Futuristic Style",
//     sporty: "Sporty Style",
//     luxury: "Luxury Style",
//     playful: "Playful Style",
//     professional: "Professional Style",
//     quirky: "Quirky Style",
//     other: "Other Style",
//   },
//   appeals_to: {
//     minimalists: "For Minimalists",
//     "adventure seekers": "For Adventure Seekers",
//     "luxury enthusiasts": "For Luxury Enthusiasts",
//     "eco-conscious": "For Eco-Conscious",
//     "tech enthusiasts": "For Tech Enthusiasts",
//     "fashion-forward": "For Fashion-Forward",
//     "budget-conscious": "For Budget-Conscious",
//     "comfort seekers": "For Comfort Seekers",
//     "creative individuals": "For Creative Types",
//     "fitness enthusiasts": "For Fitness Enthusiasts",
//     introverts: "For Introverts",
//     extroverts: "For Extroverts",
//     "practical buyers": "For Practical Buyers",
//     collectors: "For Collectors",
//     professionals: "For Professionals",
//     travelers: "For Travelers",
//     gamers: "For Gamers",
//     parents: "For Parents",
//     "pet lovers": "For Pet Lovers",
//     students: "For Students",
//     "DIY enthusiasts": "For DIY Enthusiasts",
//     "wellness-focused": "For Wellness-Focused",
//     "outdoor enthusiasts": "For Outdoor Enthusiasts",
//     homebodies: "For Homebodies",
//     trendsetters: "For Trendsetters",
//     "nostalgic buyers": "For Nostalgic Buyers",
//     "gift shoppers": "For Gift Shoppers",
//     other: "For Other Groups",
//   },
//   emotion_evoked: {
//     confidence: "Evokes Confidence",
//     comfort: "Evokes Comfort",
//     excitement: "Evokes Excitement",
//     security: "Evokes Security",
//     relaxation: "Evokes Relaxation",
//     nostalgia: "Evokes Nostalgia",
//     joy: "Evokes Joy",
//     inspiration: "Evokes Inspiration",
//     motivation: "Evokes Motivation",
//     trust: "Evokes Trust",
//     pride: "Evokes Pride",
//     curiosity: "Evokes Curiosity",
//     other: "Evokes Other Emotions",
//   },
//   lifestyle_alignment: {
//     "sustainable living": "Sustainable Lifestyle",
//     "active lifestyle": "Active Lifestyle",
//     "urban living": "Urban Lifestyle",
//     "rural living": "Rural Lifestyle",
//     "luxury living": "Luxury Lifestyle",
//     "digital nomad": "Digital Nomad Lifestyle",
//     "family-oriented": "Family-Oriented Lifestyle",
//     "pet-friendly": "Pet-Friendly Lifestyle",
//     "student life": "Student Lifestyle",
//     "professional life": "Professional Lifestyle",
//     "creative lifestyle": "Creative Lifestyle",
//     other: "Other Lifestyle",
//   },
// };

const MessageInput = ({
  onSubmit,
  placeholder = "What are you looking for today?",
  type = "submit",
  isSuccess = false,
  successMessage = "Thank you for your message!",
  error = null,
  value = "",
  onChange,
  disabled = false,
  inferredPreferences = {},
  // onPreferenceClick = () => {},
  onHeightChange = () => {},
}) => {
  const [localError, setLocalError] = React.useState(null);
  const [isReadOnly, setIsReadOnly] = React.useState(false);
  const textareaRef = useRef(null);
  const formRef = useRef(null);

  // Create a ref to store the string version of the placeholder for the textarea
  const placeholderTextRef = useRef(
    typeof placeholder === "string" ? placeholder : ""
  );

  // Update the placeholder text ref when the placeholder prop changes
  useEffect(() => {
    if (typeof placeholder === "string") {
      placeholderTextRef.current = placeholder;
    } else {
      // When using a React node placeholder, keep the textarea placeholder empty
      placeholderTextRef.current = "";
    }
  }, [placeholder]);

  // Adjust height when value changes
  useEffect(() => {
    const adjustTextareaHeight = () => {
      if (textareaRef.current) {
        // Reset height to calculate scrollHeight correctly
        textareaRef.current.style.height = "auto";
        // Set height to scrollHeight to accommodate content
        const scrollHeight = textareaRef.current.scrollHeight;
        textareaRef.current.style.height = `${scrollHeight}px`;
        onHeightChange(scrollHeight);
      }
    };

    adjustTextareaHeight();
  }, [value, onHeightChange]);

  // Handle error state timing
  useEffect(() => {
    if (error) {
      setLocalError(error);
      setIsReadOnly(true);
      const timer = setTimeout(() => {
        setLocalError(null);
        setIsReadOnly(false);
      }, 2000);
      return () => clearTimeout(timer);
    } else {
      setLocalError(null);
      setIsReadOnly(false);
    }
  }, [error]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (onSubmit && value.trim()) {
      onSubmit(value);
    }
  };

  const handleTextareaChange = (e) => {
    if (onChange) {
      onChange(e);
    }
    // Height will be adjusted in the useEffect when value changes
  };

  // Handle key press events for the textarea
  const handleKeyDown = (e) => {
    // If Enter is pressed without Shift, submit the form
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault(); // Prevent default behavior (new line)
      if (value.trim() && !disabled) {
        handleSubmit(e);
      }
    }
    // If Shift+Enter is pressed, allow the default behavior (new line)
  };

  // Determine if we should show the React node placeholder
  const shouldShowReactPlaceholder =
    typeof placeholder !== "string" && !localError && value === "";

  // Update total height when textarea changes or preferences change
  useEffect(() => {
    const updateTotalHeight = () => {
      if (formRef.current) {
        const totalHeight = formRef.current.getBoundingClientRect().height;
        onHeightChange(totalHeight);
      }
    };

    updateTotalHeight();
  }, [value, inferredPreferences, onHeightChange]);

  return (
    <form
      ref={formRef}
      onSubmit={handleSubmit}
      className="relative font-sans font-light w-full p-2"
    >
      {/* Pentatonic: solid backgrounds, no blur, clean borders */}
      <div
        className={`relative flex flex-col w-full transition-all duration-200 z-10 bg-white border border-neutral-200 ${
          isSuccess ? "opacity-0 invisible" : "opacity-100 visible"
        }`}
      >
        {/* Top row with expanding textarea */}
        <div className="w-full pt-4 px-4 pb-1">
          {/* Only show React node placeholder when appropriate */}
          {shouldShowReactPlaceholder && (
            <div className="absolute top-4 left-4 text-neutral-600 pointer-events-none">
              {placeholder}
            </div>
          )}
          <textarea
            ref={textareaRef}
            value={value}
            onChange={handleTextareaChange}
            onKeyDown={handleKeyDown}
            placeholder={
              localError ||
              (shouldShowReactPlaceholder ? "" : placeholderTextRef.current)
            }
            readOnly={isReadOnly}
            rows={1}
            className={`w-full resize-none overflow-hidden focus:outline-none focus:ring-0 text-black font-light bg-transparent min-h-[24px] h-auto ${
              localError
                ? "placeholder:text-red-500 placeholder:opacity-100"
                : "placeholder:text-[var(--color-neutral-600)]"
            } placeholder:text-neutral-600`}
            style={{
              lineHeight: "1.5rem",
            }}
          />
        </div>

        {/* Bottom row with button - Pentatonic style */}
        <div className="min-h-[48px] w-full flex justify-end items-center px-3 pb-3">
          {type === "submit" && (
            <div className="flex items-center gap-5">
              <button
                type="submit"
                disabled={disabled}
                className={`cursor-pointer hover:opacity-90 flex items-center rounded-full p-2.5 transition-all duration-200 ${!disabled ? "bg-penta-mint text-penta-black" : "bg-neutral-200 text-neutral-400 cursor-not-allowed"}`}
              >
                <ArrowRight className="h-5 w-5" strokeWidth={1.5} />
              </button>
            </div>
          )}
        </div>

        {/* {inferredPreferences && Object.keys(inferredPreferences).length > 0 && (
          <div className="w-full px-4 py-2 border-t">
            <div className="text-sm ">
              <div className="">
                <div className="flex items-center gap-2 text-neutral-600">
                  <Fingerprint className="h-3 w-3" />
                  Add to fingerprint?
                </div>
                {Object.entries(inferredPreferences)
                  .reduce((acc, [category, value]) => {
                    // Skip description, minPrice, maxPrice fields
                    if (["description", "minPrice", "maxPrice", "color"].includes(category)) {
                      return acc;
                    }
                    
                    // Handle array values (like features)
                    if (Array.isArray(value)) {
                      return [
                        ...acc,
                        ...value.map(item => ({ category, value: item }))
                      ];
                    }
                    
                    // Handle string values (like style, color, etc.)
                    return [...acc, { category, value }];
                  }, [])
                  .slice(0, 3)
                  .map(({ category, value }, index) => {
                    const displayValue =
                      PREFERENCE_DISPLAY_MAPPING[category]?.[value] || value;
                    return (
                      <span
                        key={`${value}-${index}`}
                        className="cursor-pointer underline mr-2"
                        onClick={() => {
                          const preferenceObj = {
                            [category]: Array.isArray(inferredPreferences[category]) 
                              ? [value] 
                              : value
                          };
                          onPreferenceClick(preferenceObj);
                        }}
                        onKeyDown={(e) => {
                          if (e.key === "Enter" || e.key === " ") {
                            e.preventDefault();
                            const preferenceObj = {
                              [category]: [value],
                            };
                            onPreferenceClick(preferenceObj);
                          }
                        }}
                        role="button"
                        tabIndex={0}
                      >
                        {displayValue}
                      </span>
                    );
                  })}
              </div>
            </div>
          </div>
        )} */}
      </div>

      {/* Success message */}
      {isSuccess && (
        <div className="absolute inset-0 flex items-center justify-center">
          <div className="py-3 px-5 flex items-center gap-2 text-black">
            {successMessage}
          </div>
        </div>
      )}
    </form>
  );
};

export default MessageInput;
